import {
    EVENT_CREATE_REQUEST,
    EVENT_CREATE_SUCCESS,
    EVENT_CREATE_FAIL,
    EVENT_LIST_REQUEST,
    EVENT_LIST_SUCCESS,
    EVENT_LIST_FAIL,
    EVENT_UNREAD_COUNT_REQUEST,
    EVENT_UNREAD_COUNT_SUCCESS,
    EVENT_UNREAD_COUNT_FAIL,
    EVENT_MARK_READ_SUCCESS,
    EVENT_DELETE_REQUEST,
    EVENT_DELETE_SUCCESS,
    EVENT_DELETE_FAIL
} from '../constants/eventConstant'
import eventService from '../services/eventsServices'

const getError = error => error.response && error.response.data
    ? error.response.data.error
    : error.message

export const createEvent = (data) => async (dispatch) => {
    dispatch({ type: EVENT_CREATE_REQUEST })
    try {
        const response = await eventService.create(data)
        dispatch({ type: EVENT_CREATE_SUCCESS, payload: response.data.message })
        dispatch(listEvents())
        dispatch(getUnreadEventsCount())
    } catch (error) {
        dispatch({ type: EVENT_CREATE_FAIL, payload: getError(error) })
    }
}

export const listEvents = (search) => async (dispatch) => {
    dispatch({ type: EVENT_LIST_REQUEST })
    try {
        const { data } = await eventService.list(search)
        dispatch({ type: EVENT_LIST_SUCCESS, payload: data })
    } catch (error) {
        dispatch({ type: EVENT_LIST_FAIL, payload: getError(error) })
    }
}

export const getUnreadEventsCount = () => async (dispatch) => {
    dispatch({ type: EVENT_UNREAD_COUNT_REQUEST })
    try {
        const { data } = await eventService.unreadCount()
        dispatch({ type: EVENT_UNREAD_COUNT_SUCCESS, payload: data.unreadCount })
    } catch (error) {
        dispatch({ type: EVENT_UNREAD_COUNT_FAIL, payload: getError(error) })
    }
}

export const markEventsRead = () => async (dispatch) => {
    try {
        await eventService.markRead()
        dispatch({ type: EVENT_MARK_READ_SUCCESS })
    } catch (error) {
        dispatch({ type: EVENT_UNREAD_COUNT_FAIL, payload: getError(error) })
    }
}

export const deleteEvent = (id) => async (dispatch) => {
    dispatch({ type: EVENT_DELETE_REQUEST })
    try {
        const { data } = await eventService.remove(id)
        dispatch({ type: EVENT_DELETE_SUCCESS, payload: data.message })
        dispatch(listEvents())
        dispatch(getUnreadEventsCount())
    } catch (error) {
        dispatch({ type: EVENT_DELETE_FAIL, payload: getError(error) })
    }
}
